import React from 'react'
import Content from './content/Content';
import RegistrationHeader from './registrationHeader/RegistrationHeader';
import Footer from './footer/Footer';
import Framework from 'fw/components/framework/Framework.js';
import Routes from './routes/Routes';
import * as Block from 'fw/globals/Block';

import 'css/styles.js';

class RegistrationLayout extends React.Component {
    componentWillMount() {
        document.body.setAttribute("class", "registration-body");
    }

    render() {
        return (
            <div className="registration-box wide">
                <RegistrationHeader />
                <Content>
                    <Framework />
                    <Block.Block ref={Block.hookref}>
                        <Routes />
                    </Block.Block>
                </Content>
                <Footer />
            </div >);
    }
}

export default RegistrationLayout;



// WEBPACK FOOTER //
// ./src/layouts/public/RegistrationLayout.js